export default "__VITE_ASSET__DLhCe8oD__"